const CoolDownNode = cc.Node.extend({
    ctor: function (duration, warningsLeft, booster, closeCallback) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.resolution.getBgSize().width, cleverapps.styles.CoolDownNode.height);

        this.closeCallback = closeCallback;
        this.duration = duration;
        this.warningsLeft = warningsLeft;
        this.discoverBooster = booster;

        this.createContent();
        this.createBg();

        this.onResize();
    },

    onResize: function () {
        this.bg.setContentSize2(cleverapps.resolution.getBgSize().width, this.content.height);
    },

    showUp: function (f) {
        const scene = cleverapps.Scenes.GetRunningScene();

        const start = cc.p(scene.width / 2, scene.height + this.height / 2);
        const target = cc.p(scene.width / 2, scene.height / 2);

        this.setAlignment(start);

        this.runAction(new cc.Sequence(
            new cc.MoveTo(0.5, target).easing(cc.easeBackOut()),
            new cc.CallFunc(f)
        )).setFinalize(() => {
            this.setAlignment(cleverapps.styles.CoolDownNode);
        }); 
    },

    animateClose: function (f) {
        const scene = cleverapps.Scenes.GetRunningScene();
        const finish = cc.p(scene.width / 2, -this.height / 2);

        this.runAction(new cc.Sequence(
            new cc.MoveTo(0.5, finish).easing(cc.easeBackIn()),
            new cc.RemoveSelf(),
            new cc.CallFunc(f)
        ));
    },

    createBg: function () {
        const styles = cleverapps.styles.CoolDownNode;

        const bg = this.bg = cleverapps.UI.createScale9Sprite(bundles.gamemessage.frames.gamemessage_bg_png);
        this.addChild(bg, -1);
        bg.setAlignment(styles.bg);
    },
    
    createContent: function () {
        const styles = cleverapps.styles.CoolDownNode;
        const timer = this.createTimer();
        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get("CoolDownNode.text", {
            warnings: this.warningsLeft
        }), cleverapps.styles.FONTS.WINDOW_TEXT);

        text.fitTo(this.width * 0.8);
        const items = [text, timer];
        if (this.discoverBooster) {
            items.push(this.createBuyButton());
        }

        const content = this.content = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });

        this.addChild(content);
        content.setAlignment(styles.content);
    },

    createTimer: function () {
        const countdown = new cleverapps.CountDown(this.duration, {
            onFinish: this.closeCallback,
            onTick: function (timeLeft) {
                cleverapps.effects.fire(Math.ceil(timeLeft / 1000) % 2 === 0 ? "differences.cooldown.tick1" : "differences.cooldown.tick2");
            }
        });

        const bg = cleverapps.UI.createScale9Sprite(bundles.game.frames.timer_concave_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(cleverapps.styles.CoolDownNode.timer);

        this.countView = new cleverapps.CountDownView(countdown, {
            showHours: false,
            font: cleverapps.styles.FONTS.COOLDOWNNODE_TIMER_TEXT,
            background_content: bg
        });
        return this.countView;
    },

    createBuyButton: function () {
        const styles = cleverapps.styles.DiscoverButtonBooster;

        const price = this.discoverBooster.getPrice();
        const amount = this.discoverBooster.getAmount();

        const icon = new cleverapps.Spine(bundles.game.jsons.discovery_icon_json);
        icon.setAnimation(0, "idle", true);
        icon.setScale2(styles.content.iconScale);

        let text;

        if (amount > 0) {
            text = cleverapps.UI.generateImageText(`x${amount}`, cleverapps.styles.FONTS.AMOUNT_BOOSTER);
        } else {
            text = new TextWithIcon(price.soft ? `@@${price.amount}` : `$$${price.amount}`, {
                font: cleverapps.styles.FONTS.BUTTON_BOOSTER
            });
        }

        const layout = new cleverapps.Layout([icon, text], {
            direction: styles.content.direction[cleverapps.resolution.mode],
            margin: styles.content.margin[cleverapps.resolution.mode]
        });
        layout.setAlignment(styles.content.layout);

        const content = new cc.Node();
        content.addChild(layout);

        const size = styles.size[cleverapps.resolution.mode];

        const button = new cleverapps.UI.Button({
            content,
            width: size.width,
            height: size.height,
            onClicked: function () {
                if (this.discoverBooster.canExecute() || this.discoverBooster.buy()) {
                    this.discoverBooster.execute();
                    this.closeCallback();
                }
            }.bind(this)
        });
        button.alwaysOn = true;
        return button;
    }
});

cleverapps.styles.CoolDownNode = {
    height: 460,
    margin: 15,
    pattherMargin: 0,
    padding: { x: 0, y: 50 },

    x: { align: "center" },
    y: { align: "center" },

    bg: {
        x: { align: "center" },
        y: { align: "center" }
    },

    timer: {
        width: 260,
        height: 100
    },

    button: {
        x: { align: "center" },
        y: { align: "center" }
    },

    content: {
        x: { align: "center" },
        y: { align: "center" }
    }
};